import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {
  getEcommAuthToken,
  getRetailerAuthToken,
  getRetailerInformation,
} from "~/app/modules/authentication/services";
import { Redirect, Route, withRouter } from "react-router";
import { useLocation } from 'react-router-dom'
import Provider from "~shared/singleton";
import { findURLParam } from "../../utils/urls";
import { setCookie, getCookie } from "../../utils/cookie";
import {
  isRetailerAuthRefreshFailed,
  redirectToLoginOnRefreshFailure,
} from "../../utils/authSession";
import { store } from "../../../redux/store";
import "./index.css";
import * as Bootstrap from "react-bootstrap";
const providerInstance = Provider.getInstance();
const PrivateRoute = ({
  history,
  path,
  component: Comp,
  authentication_state,
  fetchEcommAuthToken,
  fetchRetailerAuthToken,
  fetchRetailerInformation,
  ...rest
}) => {
  const [ecommLoading, setEcommLoading] = useState(true);
  const [retailerLoading, setRetailerLoading] = useState(true);
  const [tokenLoading, setTokenLoading] = useState(true);
  const [initialLoading, setInitialLoading] = useState(true);
  const authentication_ref = useRef(authentication_state);
  // window.timeZone = authentication_ref.current.retailer_info.response.default_store_timezone;

  authentication_ref.current = authentication_state;
  const getFaviconEl = () => {
    return document.getElementById("favicon");
  };
  const location = useLocation()
  const changeFavicon = (uri) => {
    const favicon = getFaviconEl(); // Accessing favicon element
    favicon.href = uri;
  };
  useEffect(() => {
    setupEnvironment();
  }, []);
  useEffect(() => {
    const getTokenExpiration = getCookie("tokenExpiration");
    const currentDate = new Date().toString();
    const expiryTimeStamp = Date.parse(getTokenExpiration);
    const currentTimeStamp = Date.parse(currentDate);
    if (initialLoading){
      setInitialLoading(false);
      return
    }
    if (!getCookie("tokenExpiration") ||
        expiryTimeStamp < currentTimeStamp) {
      setupEnvironment();
    }
  }, [
    Date.parse(getCookie("tokenExpiration")) <
      Date.parse(new Date().toString()),
  ]);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const schemaNameFromCookie = getCookie("schema_name");

    if (schemaNameFromCookie && !findURLParam("schema_name", window.location.href)) {
      urlParams.set('schema_name', schemaNameFromCookie);
      // While replacing  / adding params
      // Also persist current state in history
      // Since this state might have been used to do some business logic
      history.replace({ pathname: location.pathname, search: urlParams.toString(), state: history?.location?.state });
    }

  }, [location]);

  const setupEnvironment = () => {
    const location = window.location.href;
    const refresh_token = findURLParam("refresh_token", location)
      ? findURLParam("refresh_token", location)
      : getCookie("refresh_token");
    const schema = findURLParam("schema_name", location) 
      ? findURLParam("schema_name", location)
      : getCookie("schema_name");
    const session_key = findURLParam("session_key", location)
      ? findURLParam("session_key", location)
      : getCookie("session_key");
    /* const time_zone = findURLParam("time_zone", location)
        ? findURLParam("time_zone", location)
        : getCookie("time_zone"); */
        const time_zone = 'UTC';
        
    if (!refresh_token || !schema) {
      // window.location = `https://${authentication_ref?.current?.retailer_info?.response?.domain_url}/site-admin/login/`;
      setTokenLoading(false);
      setEcommLoading(false);
      setRetailerLoading(false);
      history.push("/access-denied");
      return;
      // providerInstance.setSchema('islandpetcenter');
      // providerInstance.setToken('772e68f5-7183-4fde-852c-20221ba172f2');
    } else {
      providerInstance.setSchema(schema);
      providerInstance.setToken(refresh_token);
      providerInstance.setSessionKey(session_key);
      providerInstance.setTimeZone(time_zone);
      setCookie("schema_name", schema);
      setCookie("refresh_token", refresh_token);
      setCookie("session_key", session_key);
      setCookie("time_zone", time_zone);
    }
    const currentDate = new Date().toString();
    const expiryStampEtail = Date.parse(getCookie("ecommExpiry"));
    const currentStamp = Date.parse(currentDate);
    if (!authentication_ref.current?.ecomm_auth?.response?.access_token ||
        (!getCookie("ecommExpiry") ||
        expiryStampEtail < currentStamp)) {
      fetchEcommAuthToken("public").then(() => {
        if (!authentication_ref?.current?.ecomm_auth?.hasError) {
          setEcommLoading(false);
          getRetailerInfo();
        } else {
          // Toast.error(authentication_ref?.current?.ecomm_auth?.error?.data || 'Something went wrong.');
        }
      });
    } else {
      setEcommLoading(false);
      getRetailerInfo();
    }
  };
  const refreshRetailerAuthToken = () => {
    const data = {
      refreshToken: providerInstance.getToken(),
    };
    fetchRetailerAuthToken(data).then(() => {
      const authState = store.getState().authentication?.retailer_auth;
      if (isRetailerAuthRefreshFailed(authState)) {
        redirectToLoginOnRefreshFailure();
        return;
      }

      const schemaName = getCookie("schema_name");
      // store access token expiration duration in local storage
      if (authState?.response?.responseData?.expiryDuration) {
        let currentdateobject = new Date();
        let tokenExpiration = new Date();
        tokenExpiration.setTime(
          currentdateobject.getTime() +
            authState.response.responseData.expiryDuration
        );
        setCookie("tokenExpiration", tokenExpiration);
        setTokenLoading(false);
      }
      if (authState?.response?.responseData?.accessToken) {
        setCookie(
          "Auth_Refresh_Token_" + schemaName,
          authState.response.responseData.accessToken
        );
      }
    });
  };
  const getRetailerInfo = () => {
    fetchRetailerInformation(providerInstance.getSchema()).then(() => {
      if (!authentication_ref?.current?.retailer_info?.hasError) {
        setRetailerLoading(false);
        changeFavicon(
          authentication_ref.current?.retailer_info?.response?.favicon
        );
        const getTokenExpiration = getCookie("tokenExpiration");
        const currentDate = new Date().toString();
        const expiryStamp = Date.parse(getTokenExpiration);
        const currentStamp = Date.parse(currentDate);
        window.timeZone = authentication_ref.current.retailer_info.response.default_store_timezone;
        window.schemasname = authentication_ref.current.retailer_info.response.schema_name
      
        if (
          !getCookie("tokenExpiration") ||
          expiryStamp < currentStamp
        ) {
          refreshRetailerAuthToken();
        } else {
          if (expiryStamp < currentStamp) {
            refreshRetailerAuthToken();
          } else {
            setTokenLoading(false);     
          }
        }
      } else {
        // window.location.reload();
        // Toast.error(authentication_ref?.current?.ecomm_auth?.error?.data || 'Something went wrong.');
      }
    });
  };
  if (ecommLoading || tokenLoading || retailerLoading)
    return (
      <div className="container-loader">
        <div className="row">
          <div className="loader-container">
            <Bootstrap.Spinner
              as="span"
              animation="border"
              size="m"
              role="status"
              aria-hidden="true"
            />
          </div>
        </div>
      </div>
    );
  return (
    <Route
      path={path}
      {...rest}
      render={(props) => {
        //user has authenticated
        return <Comp {...props} />;
      }}
    />
  );
};
PrivateRoute.propTypes = {
  history: PropTypes.shape({
    replace: PropTypes.func,
  }),
  component: PropTypes.any,
  path: PropTypes.string,
  authentication_state: PropTypes.object,
  fetchEcommAuthToken: PropTypes.func,
  fetchRetailerAuthToken: PropTypes.func,
  fetchRetailerInformation: PropTypes.func,
};
const mapStateToProps = ({ authentication }) => ({
  authentication_state: authentication,
});
export default withRouter(
  connect(mapStateToProps, {
    fetchEcommAuthToken: getEcommAuthToken,
    fetchRetailerAuthToken: getRetailerAuthToken,
    fetchRetailerInformation: getRetailerInformation,
  })(PrivateRoute)
);